// Every horizontal inset in this drawer is `--slide-panel-gutter`, the token
// SlidePanel also uses for its own header — so the title, the unread count and
// the cards all sit on one vertical grid, and the close button lines up with
// the cards' right edge. Never hard-code a gutter here.

.body {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

// Sticky so "Mark all read" stays reachable while scrolling a long list. The
// opaque background is what keeps scrolling cards from showing through; there
// is deliberately no bottom rule — the SlidePanel header already draws the only
// divider this drawer needs.
// No bottom padding: the list below opens with its own 12px top padding, and
// stacking the two read as one oversized gap under "Mark all read".
.toolbar {
  align-items: center;
  background: var(--color-background);
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 12px var(--slide-panel-gutter) 0;
  position: sticky;
  top: 0;
  z-index: 1;
}

// Cards, not rows: one gap value is the ONLY vertical spacing between them, so
// every gap in the list is equal by construction rather than by adding up
// margins.
.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 12px var(--slide-panel-gutter);
}

// Mirrors the card metrics exactly, so the list does not reflow when real
// notifications replace the placeholders.
.skeletons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px var(--slide-panel-gutter);
}

.skeleton-row {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: var(--drawer-card-radius);
  box-shadow: var(--shadow-card);
  display: grid;
  gap: 10px;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  padding: 13px 14px;
}

// Breathing room above the "all caught up" empty state only — the list and
// error states manage their own spacing. The child rule reshapes the shared
// EmptyState card into an edge-to-edge band (full drawer width, square
// corners, top/bottom rules only); `.empty > div` outweighs the card's own
// single-class rule regardless of stylesheet order, and `!important` guards
// against inline/style-order surprises in dev.
.empty {
  padding-top: 12px;

  > div {
    background: var(--color-secondary) !important;
    border-left: none !important;
    border-radius: 0 !important;
    border-right: none !important;
  }
}

.state {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 28px var(--slide-panel-gutter);
}

// Centred under the last card. No top padding — the list's own bottom gutter
// already provides the separation, so the button is not pushed twice.
.more {
  display: flex;
  justify-content: center;
  padding: 0 var(--slide-panel-gutter) 16px;
}
